import React from "react";
import ReactApexChart from "react-apexcharts";
import { isMobileView } from "../../utils/Reusables";


export default function VerticalStackedBar(props) {
  const { resultSet, COLORS_SERIES, verticalType, isLegendVisible, dateFieldFormat, handleCategoryData, columnTitle, legendPosition, pivotConfig, columnDisplayName, settings,timeDimensionDateFormat } = props;

  const result = handleCategoryData(resultSet, dateFieldFormat, pivotConfig,timeDimensionDateFormat)

  const series = resultSet.series(pivotConfig).map((s, index) => ({
    name: handleChartLabel(columnTitle, columnDisplayName, s),
    data: s.series.map((r) => (r?.value === undefined || r?.value === null || r?.value === 'NaN') ? 0 : r.value),
    backgroundColor: COLORS_SERIES[index],
    fill: false,
  }))
  let xAxisCategories = result.categories.map(obj => obj)

  const options = {
    chart: {
      type: 'bar',
      height: 350,
      stacked: true,
      stackType: '100%'
    },
    plotOptions: {
      bar: {
        horizontal: !verticalType,
      },
    },
    responsive: [{
      breakpoint: 480,
      options: {
        legend: {
          position: 'bottom',
          left: '10px',
          itemGap: 10,
          offsetX: -10,
          offsetY: 0
        }
      }
    }],
    colors: COLORS_SERIES,
    xaxis: {
      categories: xAxisCategories,
      labels: {
        rotate: -(settings?.xAxisLabelDegree) || 90,
        formatter: function (value) {
          if (!verticalType) {
            return value
          }
          if (isMobileView()) {
            if (settings?.mobile?.maxLabelCharacters && value) {
              value = value?.substring(0, Number(settings.mobile.maxLabelCharacters))
              return value
            }

            return value
          }
          else {
            if (settings?.web?.maxLabelCharacters && value) {
              value = value?.substring(0, Number(settings.web.maxLabelCharacters))
              return value
            }
            return value
          }
        }
      },
      name: settings?.axisTitle?.y?.text || '',
      nameLocation: 'middle',
      nameGap: 20

    },
    fill: {
      opacity: 1
    },
    legend: {
      position: legendPosition,
      show: isLegendVisible,
    }
  };

  return (
    <ReactApexChart
      options={options}
      series={series}
      type="bar"
      height={500}

    />
  )
}

const handleChartLabel = (columnTitle, columnDisplayName, s) => {
  let label;
  if (columnTitle && columnTitle.length && columnTitle[0][s?.key]) {
    label = columnTitle[0][s?.key]
  }
  else if (columnDisplayName && columnDisplayName[s?.key]) {
    label = columnDisplayName[s?.key]
  }
  else if (s?.key && columnDisplayName && Object.keys(columnDisplayName).length) {
    Object.keys(columnDisplayName).forEach(col => {
      if (s?.key.includes(col)) {
        s.key = s?.key.replace(col, columnDisplayName[col]);
        label = s?.key;
      }
      else {
        label = s?.title
      }
    })
  }
  else {
    label = s?.title
  }

  return label;
}
